"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreatorSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getCreatorSerializer() {
    return (0, serializers_1.struct)([
        ['address', (0, serializers_1.publicKey)()],
        ['verified', (0, serializers_1.bool)()],
        ['share', (0, serializers_1.u8)()],
    ], { description: 'Creator' });
}
exports.getCreatorSerializer = getCreatorSerializer;
//# sourceMappingURL=creator.js.map